import { zoneOffsetLabel } from '@/shared/lib/format'

/** Used where `Intl.supportedValuesOf` is missing; must at least hold the zones we operate in. */
const FALLBACK_ZONES = [
  'UTC',
  'Asia/Kabul',
  'Asia/Tashkent',
  'Asia/Almaty',
  'Asia/Dubai',
  'Asia/Karachi',
  'Asia/Tehran',
  'Europe/Moscow',
  'Europe/Istanbul',
  'Europe/London',
  'Europe/Berlin',
  'America/New_York',
] as const

export function allTimeZones(): readonly string[] {
  try {
    const intl = Intl as unknown as { supportedValuesOf?: (key: string) => string[] }
    if (typeof intl.supportedValuesOf === 'function') {
      const zones = intl.supportedValuesOf('timeZone')
      if (zones.length > 0) return zones.includes('UTC') ? zones : ['UTC', ...zones]
    }
  } catch {
    // fall back to the short list
  }
  return FALLBACK_ZONES
}

export function timeZoneOptions(): { value: string; label: string }[] {
  return allTimeZones().map((code) => ({ value: code, label: `${code} · ${zoneOffsetLabel(code)}` }))
}

/** Languages the panel is translated into; a tenant's default language is one of them. */
export const TENANT_LOCALES = ['en', 'fa', 'ru', 'uz'] as const
